<template>
  <aside class="yj-aside" :style="{ width }">
    <slot></slot>
  </aside>
</template>

<script>
  export default {
    name: 'YjAside',

    componentName: 'YjAside',

    props: {
      width: {
        type: String,
        default: '300px'
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/aside/src/aside.vue